import axios from 'axios';

const file_api = process.env.REACT_APP_FILE_URL;

const getUploadFileContext = (obj) => {
    var formData = new FormData();

    for ( var key in obj ) {
        formData.append(key, obj[key]);
    }

    return fetch(`${file_api}/api/v1/upload`, {
        method: 'POST',
        body: formData,
    })
}

const uploadFile = (url, file, progressCb, succCb) => {
    // upload to GCS storage
    return axios.put(url, file, {
        headers: {
            "Content-Length": file.size,
            "Content-Type": file.type,
        },
        onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            progressCb(progress);
        },
    })
    .then(succCb)
}

const getDownloadFileContext = (obj) => {
    var formData = new FormData();

    for ( var key in obj ) {
        formData.append(key, obj[key]);
    }

    return fetch(`${file_api}/api/v1/download`, {
        method: 'POST',
        body: formData,
    })
}

export { getUploadFileContext, uploadFile, getDownloadFileContext };